import { render } from "./DateDetail.vue?vue&type=template&id=4531b20a&scoped=true"
import script from "./DateDetail.vue?vue&type=script&lang=ts"
export * from "./DateDetail.vue?vue&type=script&lang=ts"

import "./DateDetail.vue?vue&type=style&index=0&id=4531b20a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4531b20a"

export default script